export default __webpack_public_path__ + "static/media/magiccity1.abccd923.jpg";